<template>
  <div id="headNav">
    <div class="leftArrow" @click="goBack"><van-icon name="arrow-left" /></div>
    <div class="title"><slot name="headNavText"></slot></div>
    <div class="leftArrow" ></div>
  </div>
</template>

<script>
  export default {
    name: "headNav",
    props: ['routeAddress'],
    data(){
      return{
        address:this.routeAddress
      }
    },
    methods:{
      goBack(){
        if(this.address===undefined){
          this.$router.go(-1);
        }else{
          this.$router.replace({path:this.address,query:{chntoken:sessionStorage.getItem('chntoken')}});
        }
      }

    }
  }
</script>

<style scoped lang="scss">
  #headNav{
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding: 0 10px;
    height: 1.3rem;
    line-height: 1.3rem;
    background-color: #fff;
    border-bottom: 1px solid rgba(122,122,122,0.1);
    .title{
      font-size: 18px;
      color: #262626;
      font-weight: 500;
    }
    .leftArrow{
      font-size: 18px;
      display: flex;
      align-items: center;
      width: 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/HeadNav/headNav.vue